import { Typography } from "@circle-react-shared/uikit/Typography";
import { Children, Fragment, type ReactNode } from "react";

export interface ComposedItem {
  items: ReactNode[];
  label: string;
}

export interface BulletedListProps {
  composedItems?: ComposedItem[];
  items?: ReactNode[];
}

export const BulletedList = ({ items, composedItems }: BulletedListProps) => (
  <div className="p-4">
    {composedItems && composedItems.length > 0 ? (
      composedItems.map(composedItem => (
        <Fragment key={composedItem.label}>
          <Typography.BodySm>{composedItem.label}</Typography.BodySm>
          <ul className="list-outside list-disc pb-1 pl-5 marker:text-blue-500">
            {Children.map(composedItem.items, item => (
              <li className="pb-1">
                <Typography.BodySm>{item}</Typography.BodySm>
              </li>
            ))}
          </ul>
        </Fragment>
      ))
    ) : (
      <ul className="list-outside list-disc pl-5">
        {Children.map(items, item => (
          <li>
            <Typography.BodySm>{item}</Typography.BodySm>
          </li>
        ))}
      </ul>
    )}
  </div>
);
